import { useState } from 'react'

import { CardType, defaultCard } from 'types/deck'
import { CustomCard } from 'services/apiTypes/customCards.types'

import CardDetailsOverlay from 'components/elements/Overlay/CardDetailsOverlay'
import CustomCardEditForm from 'components/customCards/CustomCardEditForm'
import InDecks from 'components/collectionV2/cardDetails/InDecks'

type Props = {
  card: CardType | null
  onClose: () => void
  onCardEdited: (updatedCard: CustomCard) => void
  saveableByDefault?: boolean
}

const CustomCardOverlay = ({ card, onCardEdited, saveableByDefault, onClose }: Props) => {
  const [activeTab, setActiveTab] = useState<'edit' | 'customInDecks'>('edit')
  const [displayCard, setDisplayCard] = useState(card || null) // Data updated when card is EDITED but not SAVED. Useful for displaying changes to the card in real time

  return (
    <CardDetailsOverlay
      nowWeirdClose
      open={!!card}
      card={displayCard || card || defaultCard}
      onClose={onClose}
      activeTabId={activeTab}
      onTabChange={setActiveTab}
      rightControls={null}
      tabs={[
        {
          label: 'Edit Custom Card',
          id: 'edit',
          body: (
            <CustomCardEditForm
              card={card}
              onCardEdited={onCardEdited}
              onDisplayCardEdited={setDisplayCard}
              saveableByDefault={saveableByDefault}
            />
          ),
        },
        {
          label: 'In decks',
          id: 'customInDecks',
          disabled: !card?.customCard?.id,
          body: <InDecks card={card || defaultCard} />,
        },
      ]}
    />
  )
}

export default CustomCardOverlay
